export class ChangePasswordRequest { 
    
    public userName : string | null="";
    public oldPassword : string="";
    public newPassword : string="";
    
}